import { SelfServeNodes } from "../types";

import { useFaireProgramsRetailerNodes } from "./nodes/useFaireProgramsRetailerNodes";
import { useHowFaireWorksRetailerNodes } from "./nodes/useHowFaireWorksRetailerNodes";
import { useInsiderRetailerNodes } from "./nodes/useInsiderRetailerNodes";
import { useInvoicesRetailerNodes } from "./nodes/useInvoicesRetailerNodes";
import { useOrdersRetailerNodes } from "./nodes/useOrdersRetailerNodes";
import { usePaymentsRetailerNodes } from "./nodes/usePaymentsRetailerNodes";
import { useSettingsRetailerNodes } from "./nodes/useSettingsRetailerNodes";
import { useVerifyAccountRetailerNodes } from "./nodes/useVerifyAccountRetailerNodes";

export const useRetailerNodes = (): SelfServeNodes => {
  const verifyAccountRetailerNodes = useVerifyAccountRetailerNodes();
  const ordersRetailerNodes = useOrdersRetailerNodes();
  const settingsRetailerNodes = useSettingsRetailerNodes();
  const paymentsRetailerNodes = usePaymentsRetailerNodes();
  const invoicesRetailerNodes = useInvoicesRetailerNodes();
  const insiderRetailerNodes = useInsiderRetailerNodes();
  const faireProgramsRetailerNodes = useFaireProgramsRetailerNodes();
  const howFaireWorksRetailerNodes = useHowFaireWorksRetailerNodes();

  return {
    Root: {
      id: "Root",
      children: [
        "VerifyAccount",
        "Orders",
        "SettingsAndAccount",
        "Payments",
        "Invoices",
        "Insider",
        "FairePrograms",
        "HowFaireWorks",
      ],
      level: 0,
    },
    ...verifyAccountRetailerNodes,
    ...ordersRetailerNodes,
    ...settingsRetailerNodes,
    ...paymentsRetailerNodes,
    ...invoicesRetailerNodes,
    ...insiderRetailerNodes,
    ...faireProgramsRetailerNodes,
    ...howFaireWorksRetailerNodes,
  };
};
